import React, {useState} from 'react';
import {Text, TouchableOpacity} from 'react-native';
import Entypo from 'react-native-vector-icons/Entypo';
import {styles} from './styles';

interface ISupportDesc {
  title?: string;
  description?: string;
}

const SupportDesc = ({title, description}: ISupportDesc) => {
  const [showDetails, setShowDetails] = useState<boolean>(false);

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  return (
    <>
      <TouchableOpacity style={styles.containerTitle} onPress={toggleDetails}>
        <Text style={styles.title}>{title}</Text>
        {showDetails ? (
          <Entypo name="minus" size={18} color={'black'} />
        ) : (
          <Entypo name="plus" size={18} color={'black'} />
        )}
      </TouchableOpacity>
      {showDetails && <Text style={styles.description}>{description}</Text>}
    </>
  );
};

export default SupportDesc;
